// extracted by css-extract-rspack-plugin
export default {"itemWrapper":"qy4Qy","chevronDown":"Z6o6s"};